
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { WorksheetFormValues } from "@/components/admin/worksheet/worksheetFormSchema";
import { createSearchIndex } from "./searchUtils";

export const useWorksheetCreate = () => {
  const { toast } = useToast();

  const createWorksheet = async (newWorksheet: WorksheetFormValues) => {
    try {
      // Create search index
      const searchIndex = createSearchIndex(
        newWorksheet.name, 
        newWorksheet.subject, 
        newWorksheet.grade_level
      );
      
      // Make sure document_urls is an array (this should be handled by the schema transform)
      const document_urls = newWorksheet.document_urls;
      
      const { data, error } = await supabase
        .from("worksheets")
        .insert({
          name: newWorksheet.name,
          subject: newWorksheet.subject,
          grade_level: newWorksheet.grade_level,
          semester: newWorksheet.semester || null,
          fs_name: newWorksheet.fs_name || null,
          document_urls,
          status: newWorksheet.status || null,
          search_index: searchIndex,
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString()
        })
        .select();
        
      if (error) throw error;
      
      toast({
        title: "เพิ่มชีทสำเร็จ",
        description: "เพิ่มชีทใหม่เรียบร้อยแล้ว",
      });
      
      return data[0];
    } catch (error: any) {
      console.error("Error creating worksheet:", error.message);
      toast({
        title: "เกิดข้อผิดพลาด",
        description: `ไม่สามารถเพิ่มชีทได้: ${error.message}`,
        variant: "destructive"
      });
      return null;
    }
  };

  return { createWorksheet };
};
